import axios from "axios";
import Vue from 'vue';
// 创建vue实例
let vue = new Vue();
const IS_PROD = ["production", "prod"].includes(process.env.NODE_ENV);
// 接口路径
const BASEURL_TEST = 'https://test5.douniu8.com'
// const BASEURL_TEST = 'http://127.0.0.1:8080'
const BASEURL_PROD = 'https://test5.douniu8.com'
const baseURL =  IS_PROD ? BASEURL_PROD : BASEURL_TEST;
// 登录service(不带token)
const loginService = axios.create({
  baseURL: baseURL, // api的base_url
  timeout: 1000 * 60, // 请求超时时间
  withCredentials: true, //
});
/****** request拦截器==>对请求参数做处理 ******/
loginService.interceptors.request.use(config => {
  // 判断token状态
  var token = window.localStorage.getItem('token');
  // console.log("是打发斯蒂芬"+token)
  /*// 没有token跳转登录页
  if (!token)  {
    Vue.prototype.router.push({
      path: '/login'
    });
  }*/
  // 设置请求头token
  config.headers['Authorization'] = "Bearer " + token;
  return config;
}, error => { //请求错误处理
  console.log(error)
});


export default {
  loginService,
  baseURL
};



// WEBPACK FOOTER //
// ./src/axios/request.js